// File: Home.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import NavBar from './NavBar';
import './Home.css';
import home1 from '../Assets/Techstrike_logo.png';
import heroVideo from '../Assets/bgvid.mp4';
import gallery1 from '../Assets/logo_rm.png';
import gallery2 from '../Assets/hm01.jpg';
import gallery3 from '../Assets/hm02.jpg';
import gallery4 from '../Assets/hm03.jpg';
import gallery5 from '../Assets/hm04.jpg';
import gallery6 from '../Assets/hm05.jpg';
import gallery8 from '../Assets/robotics.jpg';
import gallery9 from '../Assets/gamingimages01.jpg';
import { Gamepad2, Cpu, Bot, Users } from 'lucide-react';
import { FaWhatsapp, FaFacebookF, FaInstagram } from 'react-icons/fa';
import API_BASE_URL from '../config';
// import { announcements } from './utils/announcementsData'; // Import shared data - REMOVED



const Home = ({ onLoginClick }) => {
  const navigate = useNavigate();
  const handleLearnMoreClick = () => navigate('/about-us');
  const handleGetStarted = () => navigate('/signup');

  const galleryImages = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];


  // Gallery slider (fade)
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [galleryImages.length]);

  const words = React.useMemo(() => [
    'who build the projects...',
    'who compete in tournaments...',
    'who innovate through workshops...',
    'who mentor the next generation...',
    'who collaborate on creative ideas...'
  ], []);

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    const currentWord = words[currentWordIndex];

    const typingSpeed = 6; // milliseconds per letter
    const deletingSpeed = 10;
    const pauseTime = 1500; // pause at the end of the word

    let timeout;

    if (!isDeleting) {
      // Typing letters
      if (displayedText.length < currentWord.length) {
        timeout = setTimeout(() => {
          setDisplayedText(currentWord.slice(0, displayedText.length + 1));
        }, typingSpeed);
      } else {
        // Word fully typed, pause then start deleting
        timeout = setTimeout(() => setIsDeleting(true), pauseTime);
      }
    } else {
      // Deleting letters
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText(currentWord.slice(0, displayedText.length - 1));
        }, deletingSpeed);
      } else {
        // Word fully deleted, move to next word
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, currentWordIndex, words]);


  const features = [
    {
      icon: <Gamepad2 size={40} strokeWidth={1.5} color="#3b82f6" />,
      title: 'Gaming Events',
      description: 'Competitive & casual gaming tournaments.',
      descriptionund: 'Powered by Techstrike@25',
      bgImages: [gallery9, gallery2, gallery3]
    },
    {
      icon: <Cpu size={40} strokeWidth={1.5} color="#3b82f6" />,
      title: 'Workshops',
      description: 'Hands-on workshops for web, AI & embedded systems.',
      descriptionund: 'Powered by Techstrike@25',
      bgImages: [gallery2, gallery3, gallery4]
    },
    {
      icon: <Bot size={40} strokeWidth={1.5} color="#3b82f6" />,
      title: 'Robotics & IOT',
      description: 'Build, program and compete with robots.',
      descriptionund: 'Powered by Techstrike@25',
      bgImages: [gallery8, gallery4, gallery5]
    },
    {
      icon: <Users size={40} strokeWidth={1.5} color="#3b82f6" />,
      title: 'Networking',
      description: 'Meet industry mentors and fellow creators.',
      descriptionund: 'Powered by Techstrike@25',
      bgImages: [gallery3, gallery5, gallery6]
    },
  ];



  const FeatureCard = ({ feature }) => {
    const [currentBgIndex, setCurrentBgIndex] = React.useState(0);

    React.useEffect(() => {
      const interval = setInterval(() => {
        setCurrentBgIndex((prev) => (prev + 1) % feature.bgImages.length);
      }, 3500);
      return () => clearInterval(interval);
    }, [feature.bgImages.length]);

    return (
      <div
        className="feature-card-full"
        style={{ backgroundImage: `url(${feature.bgImages[currentBgIndex]})` }}
      >
        {/* TechStrike logo (shows only on hover) */}
        <img
          src={home1}
          alt="TechStrike Logo"
          className="feature-logo-hover"
        />

        {/* Normal content (hidden on hover) */}
        <div className="feature-content">
          <div className="feature-icon">{feature.icon}</div>
          <h3 className="feature-h">{feature.title}</h3>
          <p className="feature-p">{feature.description}</p>
          <p id="watermark">{feature.descriptionund}</p>
        </div>
      </div>
    );
  };



  // Reveal on scroll helper
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) en.target.classList.add('revealed');
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  // Fetch announcements from backend
  const [announcementsData, setAnnouncementsData] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/announcements`);
        const data = await response.json();
        if (data.success) {
          setAnnouncementsData(data.data);
        }
      } catch (error) {
        console.error('Error fetching announcements:', error);
      }
    };
    fetchAnnouncements();
  }, []);

  // Map shared announcements to the format Home page expects
  const newsItems = announcementsData.map(a => ({
    title: a.title,
    description: a.description,
    date: new Date(a.eventDate || a.createdAt).toLocaleDateString(),
    img: a.image ? (a.image.startsWith('http') ? a.image : `${API_BASE_URL}/${a.image.replace(/\\/g, '/')}`) : gallery1,
    link: '/Announcement',
    btnText: 'Read More'
  }));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % newsItems.length);
    }, 4000); // change every 4 seconds

    return () => clearInterval(interval);
  }, [newsItems.length]);






  return (
    <div className="home-root">

      <NavBar onLoginClick={onLoginClick} />
      <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <main className="home-main">

        {/* HERO */}
        <section className="hero reveal">


          <div className="hero-overlay" /> {/* optional dark overlay for text readability */}

          <div className="hero-left">
            <motion.h1
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="hero-title"
            >
              <h3 id="title">WELCOME</h3>
              <h1 id="title2">TechStrike Club</h1>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="hero-sub"
            >
              <p id="phg">
                Learn, innovate, and grow with a community of tech enthusiasts and future leaders.
                <span className="typing">{displayedText}</span>
                <span className="cursor">|</span>
              </p>




            </motion.p>
            <div className="rightsmall">
              <div className="hero-actions">
                <motion.button
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                  className="btn primary"
                  onClick={handleGetStarted}
                >
                  Get Started
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.98 }}
                  className="btn primary"
                  onClick={handleLearnMoreClick}
                >
                  Learn more
                </motion.button>
              </div>


            </div>
          </div>
          <div className="flag-container">
            <motion.img
              src={home1}
              alt="TechStrike Logo"
              className="flag-logo"

            />
          </div>
        </section>

        <section className="features-full reveal">
          <div className="features-full-grid">
            {features.map((f, i) => (
              <FeatureCard key={i} feature={f} />
            ))}
          </div>
        </section>




        {/* NEWS / EVENTS */}
        {/* 🔥 NEWS / EVENTS SECTION (Slider Style) */}
        <section className="news-section reveal">
          <h2 className="section-heading">Latest from the Club</h2>
          {newsItems.length > 0 ? (
            <div className="news-slider">
              {newsItems.map((item, index) => (
                <motion.div
                  key={index}
                  className={`news-slide ${index === currentIndex ? 'active' : ''}`}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: index === currentIndex ? 1 : 0 }}
                  transition={{ duration: 0.8 }}
                >
                  <div className="news-image" style={{ backgroundImage: `url(${item.img})` }}></div>
                  <div className="news-overlay">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                    <div className="news-meta">
                      <span className="news-date">{item.date}</span>
                      <button className="btn primary" onClick={() => navigate(item.link)}>
                        {item.btnText}
                      </button>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="no-news-message" style={{ textAlign: 'center', padding: '50px', fontSize: '1.2rem', color: '#666' }}>
              <p>No news to show</p>
            </div>
          )}

          <div className="news-controls">
            {newsItems.length > 0 && newsItems.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              ></button>
            ))}
          </div>

          <div className="news-btn-wrapper">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
              className="btn view-all-btn"
              onClick={() => navigate('/Announcement')}
            >
              View All
            </motion.button>
          </div>
        </section>



        {/* TESTIMONIALS + SPONSORS */}
        <section className="social reveal">
          <div className="social-left">
            <h2 className="section-headingli">Director’s Message</h2>
            <div className="testimonial">
              <p> " Welcome to the Techstrike Club! <br />

                At Techstrike, we believe that innovation begins with curiosity and teamwork. Our mission is to create a
                space where students can explore emerging technologies, share creative ideas, and transform them into
                impactful real-world solutions.

                Through our projects, workshops, and competitions, we aim to inspire every member to develop their technical
                skills, leadership qualities, and collaborative spirit. The dedication and enthusiasm of our members continue
                to make Techstrike a driving force of innovation within our faculty.

                I invite all students to take part in this journey to learn, to create, and to make a difference.
                Together, let’s shape the future of technology and lead with passion and purpose."</p>
              <strong>Pasindu Amarasinghe <br />Director <br />Techstrike Club</strong>
            </div>
          </div>
          <div className="social-right">
            <h3>Join the Community</h3>
            <p>Connect with TechStrike across our social platforms and be part of our growing network!</p>

            <div className="social-platforms">
              <div className="social-card">
                <a
                  href="https://chat.whatsapp.com/J4BpgflCpk15ltcHqp4xIh"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>

              </div>

              <div className="social-card">
                <a
                  href="https://www.facebook.com/TechStrikeCINEC/"
                  target="_blank"
                  rel="noopener noreferrer"
                > <FaFacebookF />
                </a>

              </div>

              <div className="social-card">
                <a
                  href="https://instagram.com/techstrike2k21?igshid=xo2f6nqacm26"
                  target="_blank"
                  rel="noopener noreferrer"
                >   <FaInstagram />
                </a>
              </div>
            </div>
          </div>

        </section>

        {/* CTA */}
        <section className="final-cta reveal">
          <motion.div className="cta-card" initial={{ scale: 0.98, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.5 }}>
            <h2 className='finalh'>Ready to level up?</h2>
            <p className='finalha'>Become a member, volunteer as an organizer, or propose an event... <br /> Then join our core pillars</p>
            <div className="cta-actions">
              <button className="btn primary" onClick={() => navigate('/Sub_Pillars')}>Join core Pillars</button>
              <button className="btn ghost" onClick={() => navigate('/Sub_Pillars')}>view core Pillars</button>
            </div>
          </motion.div>
        </section>
      </main>
      <br /><br />

    </div>
  );
};

export default Home;